import { showConfirmationPopupAction } from 'js/components/common/popups/ConfirmationPopup';

import * as server from './server';

export const showCoolingOffPopupAction = ({ id, content }) => {
    const onAccept = () => server.acceptCoolingOff(true);
    const onDecline = () => server.acceptCoolingOff(false);

    return showConfirmationPopupAction({
        id,
        className: 'cooling-off-popup',
        title: 'playtech.mobile.system.coolingOff.title.message',
        content,
        onAccept,
        onDecline
    });
};
